import React, { useState } from "react";
import cn from "classnames";

import Divider from "components/Design/Divider/Divider";
import { fullWidth } from "components/Design/ArtDirectedImage";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  CardContactUs,
  CardContactUsLight,
  CardContactUsWedding,
  CardContactUsPrimary,
  CardContactUsContent,
} from "./CardContactUs";
import DestinationCard from "./DestinationCard";
import { CardRoom, CardRoomListMobile, CardHighlightRoom } from "./CardRoom";
import { PlayIcon } from "components/Icons";
import { CardPricing, CardActivitiesPricing } from "./CardPricing";
import { CardValidity } from "./CardValidity";
import { CardHotel, CardHotelList } from "./CardHotels";
import EmptyCard from "./EmptyCard";
import { BALI } from "store/constants/hotel";

const CardAnimatedCarouselThumbnail = ({ image, onClick, isVideo }) => {
  const [isSwiping, setSwiping] = useState(false);
  return (
    <div
      className={cn("relative h-full w-full rounded-sm overflow-hidden", {
        "cursor-pointer": onClick && (image.isPopup || Boolean(image.cta_link)),
      })}
      onClick={onClick}>
      {image && image.desktop && (
        <GatsbyImage
          image={fullWidth(image.desktop)}
          className="image-rounded-iphone h-full"
          loading="lazy"
        />
      )}
      <div className="bg-card-overlay h-1/4 min-h-80 max-h-100 w-full absolute bottom-0 left-0 rounded-b-sm" />
      <div className="absolute bottom-0 left-0 py-16 px-20 z-10 rounded-sm">
        <p className="uppercase font-bold text-white text-14-22 tracking-8">
          {image.title}
        </p>
      </div>
      {image.cta_link && (
        <div className="absolute inset-0 m-auto flex justify-center items-center z-2 ">
          <PlayIcon />
        </div>
      )}
    </div>
  );
};

const CardWithContent = ({ title, children, className, type, location }) => {
  return (
    <div
      className={cn(className, {
        "pb-30 lg:pb-20": type !== "gray" && location !== BALI,
        "pb-20": location === BALI,
      })}>
      <div
        className={cn("font-mulish my-6 font-bold uppercase text-12-18", {
          "text-gray-text": type === "gray",
          "text-gold tracking-8": type === "gold" || location === BALI,
        })}>
        {title}
      </div>
      <Divider />
      {children}
    </div>
  );
};
CardWithContent.defaultProps = {
  type: "gold",
  className: "",
};
const CardWithList = ({ title, children }) => {
  return (
    <div className="pb-10 md:pb-20">
      <div className="font-mulish text-14-24 text-gray-text-2 pb-8">
        {title}
      </div>
      {children}
    </div>
  );
};

export {
  CardAnimatedCarouselThumbnail,
  DestinationCard,
  CardContactUs,
  CardContactUsLight,
  CardContactUsWedding,
  CardContactUsPrimary,
  CardContactUsContent,
  CardRoom,
  CardRoomListMobile,
  CardHighlightRoom,
  CardPricing,
  CardActivitiesPricing,
  CardWithContent,
  CardWithList,
  CardValidity,
  CardHotel,
  CardHotelList,
  EmptyCard,
};
